const EVENT_ONLINE = 'online' as const;
const EVENT_OFFLINE = 'offline' as const;

type Callback = (event: Event) => void;

function _window(): Window | undefined {
    return globalThis.window ?? undefined;
}

function subscribeOnlineStatusChange(callback: Callback) {
    const globalWindow = _window();

    globalWindow?.addEventListener(EVENT_ONLINE, callback);
    globalWindow?.addEventListener(EVENT_OFFLINE, callback);
}

function unsubscribeOnlineStatusChange(callback: Callback) {
    const globalWindow = _window();

    globalWindow?.removeEventListener(EVENT_ONLINE, callback);
    globalWindow?.removeEventListener(EVENT_OFFLINE, callback);
}

export default {
    subscribeOnlineStatusChange,
    unsubscribeOnlineStatusChange,
};
